@if (Vendor) {
  <div class="container-fluid h-100">
    <div class="row h-100">
      <div class="col h-100">
        <app-invoices-grid
          [gridName]="'VendorInvoices'"
          [suppliedQueryData]="SuppliedQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [getCalculatedColumnActions]="getCalculatedColumnActions"
          (actionEvent)="actionEvent($event)"
        ></app-invoices-grid>
      </div>
    </div>
  </div>
}
